import LinkedLogicsList from './LinkedLogicsList'

export default LinkedLogicsList
